const Settings = require('./domain/Settings'),
	adManager = require('./services/adManager'),
	breakpoints = require('../services/breakpoints'),
	sizeMappings = require('../services/sizeMappings'),
	slotManager = require('./services/slotManager'),
	lazyLoadService = require('../services/lazyLoadService'),
	closeableAdManager = require('../services/closeableAdManager'),
	targeting = require('./services/targeting'),
	hooks = require('../utils/hooks'),
	cmd = require('../utils/cmd'),
	pubsub = require('../utils/pubsub'),
	prebid = require('../prebid/index'),
	prebidService = require('../prebid/prebidService');

require('../utils/debug');

async function init(config, userHooks) {
	const {
		'xandr': xandrConfig,
		'prebid': prebidConfig
	} = config;

	_coreInit(userHooks);

	if (prebidConfig) {
		_prebidInit(prebidConfig);
	}

	await _xandrInit(xandrConfig);

	cmd.accept('loaded');
}

function _coreInit(userHooks = {}) {
	performance.mark('advert - core - initialisation - start');

	hooks.init(userHooks);
	window.advert.addHook = hooks.add;

	performance.mark('advert - core - initialisation - end');
}

function _prebidInit(config) {
	prebid.init(config);
}

async function _xandrInit(config) {
	performance.mark('advert - xandr - initialisation - start');

	const settings = new Settings(config);

	await lazyLoadService.init(settings);
	await breakpoints.init(settings);
	await targeting.init(settings);
	await sizeMappings.init(settings); // Depends on breakpoints
	await adManager.init(settings); // Depends on sizeMappings & breakpoints
	await slotManager.init(settings); // Depends on ad manager
	await closeableAdManager.init(slotManager);

	performance.mark('advert - xandr - initialisation - end');
}

const initialCmds = window.advert && window.advert.cmd || [];

window.advert = Object.assign({}, window.advert, {
	init,
	pubsub,
	cmd,
	'loadSlot': slotManager.loadSlot,
	'getSlot': slotManager.getSlot,
	'getSlots': slotManager.getSlots,
	'getCurrentBreakpoint': breakpoints.getCurrentBreakpoint,
	'getSizeMapping': sizeMappings.getSizeMapping,
	'getBidResults': prebidService.getBidResults
});

cmd.init(initialCmds, ['ready']);
